import { render, staticRenderFns } from "./AccidentPage.vue?vue&type=template&id=711ca1d6&"
import script from "./AccidentPage.vue?vue&type=script&lang=js&"
export * from "./AccidentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports